import { render } from "./Team_manager_adviser_en_m.vue?vue&type=template&id=15a28d8f&scoped=true"
import script from "./Team_manager_adviser_en_m.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser_en_m.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-15a28d8f"

export default script